import type { App } from 'vue'
// @ts-ignore
import * as rechargingComponents from '@npm/recharging-components'
// @ts-ignore
import * as cenamComponents from '@npm/recharging-cenam'
import '@npm/atlas-css/dist/index.css'
import '@npm/recharging-cenam/dist/style.css'
import '@npm/recharging-cenam/dist/assets/styles/card.css'
import '@npm/recharging-cenam/dist/assets/styles/atlas.css'

export const setupOfferComponent = (app: App<Element>) => {
  app.use(rechargingComponents)
  app.use(cenamComponents)
}
